import { CuerpoLayout } from '@/components/oposiciones/CuerpoLayout';

export function OposicionesIIPPLayout() {
  return (
    <CuerpoLayout
      basePath="/app/oposiciones-iipp"
      shortLabel="Ayudante II.PP."
      accent="red"
      areaId="iipp"
      downloadsMode="oposiciones_iipp"
      caseLabel="Supuestos"
    />
  );
}
